import React from "react";
import PurchaseContent from "./PurchaseContent";
import NavBar from "../NavBar";
import Footer from "../Footer";

function PurchaseMain() {
  return (
    <div className="p-3">
      {/*Add title and metadata */}
      <title>Change Password</title>
      <meta name="robots" content="noindex"></meta>

      {/*navbar*/}
      <NavBar />
      {/* Purchase body */}
      <PurchaseContent />
      {/* Footer */}
      <Footer />
    </div>
  );
}

export default PurchaseMain;
